export default {
  getFilters: state => state.availableFilters
}
